module.exports = __webpack_public_path__ + "static/childcouncil_card_img6@2x-2ab0a6367ce599de44dc2d039a025521.jpg";